import {
  CreateMessageTemplateRequest,
  EmailDesignContent,
  MessageDesignContent,
  MessageTemplateContent,
  MessageTemplateMutationResponse,
  MessageTemplatesListParams,
  MessageTemplatesListResponse,
  MessageTemplateWithUsage,
  UpdateMessageTemplateRequest,
} from '@app/models/messageTemplates';
import { DEFAULT_EMAIL_DESIGN_CONTENT, DEFAULT_MESSAGE_DESIGN_CONTENT } from '@app/utils/consts';
import { apiInstance } from './api';
import { ApiRoutes } from './consts';

export const getMessageTemplates = async (params: MessageTemplatesListParams) => {
  return apiInstance.get<MessageTemplatesListResponse>(`${ApiRoutes.MessageTemplates}`, { params });
};

export const getMessageTemplate = async (id: string) => {
  return apiInstance.get<MessageTemplateWithUsage>(`${ApiRoutes.MessageTemplates}/${id}`);
};

export const createMessageTemplate = async (data: CreateMessageTemplateRequest) => {
  return apiInstance.post<MessageTemplateMutationResponse>(`${ApiRoutes.MessageTemplates}`, data);
};

export const updateMessageTemplate = async (id: string, data: UpdateMessageTemplateRequest) => {
  return apiInstance.put<MessageTemplateMutationResponse>(`${ApiRoutes.MessageTemplates}/${id}`, data);
};

export const deleteMessageTemplate = async (id: string) => {
  return apiInstance.delete<{ message: string }>(`${ApiRoutes.MessageTemplates}/${id}`);
};

export const setDefaultMessageTemplate = async (id: string) => {
  return apiInstance.post<MessageTemplateMutationResponse>(`${ApiRoutes.MessageTemplates}/${id}/default`);
};

// Sends the saved version of an email template to the current user's account email
export const sendTestMessageTemplate = async (id: string) => {
  return apiInstance.post<{ message: string; email: string }>(`${ApiRoutes.MessageTemplates}/${id}/test`);
};

// Mappers between the backend template fields and the editor content shapes. Empty (null) fields fall back to the editor defaults.
// The to-content mappers also take an automation's custom design rows (`emailDesigns`), which use the same fields
export const templateToEmailContent = (template: MessageTemplateContent): EmailDesignContent => ({
  subject: template.subject ?? DEFAULT_EMAIL_DESIGN_CONTENT.subject,
  heading: template.heading ?? DEFAULT_EMAIL_DESIGN_CONTENT.heading,
  message: template.message ?? DEFAULT_EMAIL_DESIGN_CONTENT.message,
  buttonText: template.buttonText ?? DEFAULT_EMAIL_DESIGN_CONTENT.buttonText,
  buttonColor: template.buttonColor ?? DEFAULT_EMAIL_DESIGN_CONTENT.buttonColor,
  logoUrl: template.logo ?? '',
});

export const emailContentToTemplate = (content: EmailDesignContent): MessageTemplateContent => ({
  subject: content.subject,
  heading: content.heading,
  message: content.message,
  buttonText: content.buttonText,
  buttonColor: content.buttonColor,
  logo: content.logoUrl,
});

export const templateToMessageContent = (template: MessageTemplateContent): MessageDesignContent => ({
  logoUrl: template.logo ?? '',
  previewName: template.heading ?? DEFAULT_MESSAGE_DESIGN_CONTENT.previewName,
  message: template.message ?? DEFAULT_MESSAGE_DESIGN_CONTENT.message,
});

export const messageContentToTemplate = (content: MessageDesignContent): MessageTemplateContent => ({
  logo: content.logoUrl,
  heading: content.previewName,
  message: content.message,
});
